import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateBuyNotificationHTML = (userData, paymentDetails) => {
  const adminLink = `${BASE_URL}/userdetail/${userData.uid}`;
  const amount = typeof paymentDetails.amount === 'number' ? paymentDetails.amount.toFixed(2) : paymentDetails.amount;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #2c3d4f, #1a1a1a); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; font-family: sans-serif; line-height: 1.6; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; min-width: 140px; display: inline-block; }
        .btn { display: inline-block; padding: 12px 30px; background: #2C3D4F; color: #ffffff; text-decoration: none; border-radius: 5px; margin: 20px 0; font-weight: bold; }
      </style>
    </head>
    <body>
      <div>
        <div class="header">
          <h1>New Buy Crypto Request</h1>
        </div>
        <div class="content">
          <p>A user has submitted a buy crypto request on <strong>${BRAND_NAME}</strong>.</p>
          
          <div class="info-box">
            <p><span class="label">User Name:</span> ${userData.fullName}</p>
            <p><span class="label">Email:</span> ${userData.email}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Payment Method:</span> ${paymentDetails.accountType}</p>
            <p><span class="label">Account Name:</span> ${paymentDetails.accountName}</p>
            <p><span class="label">Account Address:</span> ${paymentDetails.address}</p>
            ${paymentDetails.memo ? `<p><span class="label">Memo:</span> ${paymentDetails.memo}</p>` : ""}
            <p><span class="label">Date:</span> ${paymentDetails.date}</p>
            <p><span class="label">Status:</span> ${paymentDetails.status}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${adminLink}" class="btn">View User Details</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendBuyNotificationEmail = async (userData, paymentDetails) => {
  console.log("📧 Sending buy crypto notification...", { SUPPORT_EMAIL, paymentDetails });
  try {
    const html = generateBuyNotificationHTML(userData, paymentDetails);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Buy crypto notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending buy crypto notification:", error);
    return false;
  }
};
